(function() {
    // Add class to form inputs with datapicker
    let inputDate = document.querySelectorAll('form input.datepicker');
    inputDate.forEach(item => {
        item.parentNode.classList.add('datepicker-container');
    });

    // Arrows input[number] increase and decrease
    let inputNumber = document.querySelectorAll('form input[type=number]');
    inputNumber.forEach(item => {
        let numberArrowDown = document.createElement('div');
        let numberArrowUp = document.createElement('div');

        numberArrowUp.className = 'number-arrow arrow-up';
        numberArrowDown.className = 'number-arrow arrow-down';

        item.parentNode.appendChild(numberArrowUp);
        item.parentNode.appendChild(numberArrowDown);

        item.parentNode.classList.add('number-container');

        item.parentNode.addEventListener('click', event => {
            if(event.target.classList.contains('arrow-down')) {
                if(item.value === '') {
                    item.value = 0
                }else if(item.value > 0) {
                    item.value = parseInt(item.value, 10) - 1;
                }
            }else if(event.target.classList.contains('arrow-up')) {
                if(item.value === '') {
                    item.value = 0;
                }else {
                    item.value = parseInt(item.value) + 1;
                }
            }
        });
    });

    // mobile menu
    let buttonClose = document.querySelector('#close-mobile-button');
    let buttonOpen = document.querySelector('#menu-bars-button');
    let mobileMenu = document.querySelector('#mobile-menu');
    if(buttonClose && mobileMenu && buttonOpen) {
        buttonClose.addEventListener('click', () => {
            mobileMenu.classList.add('close-menu');
            mobileMenu.classList.remove('open-menu');
        });
        buttonOpen.addEventListener('click', () => {
            mobileMenu.classList.add('open-menu');
            mobileMenu.classList.remove('close-menu');
        });
    }
})()